import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFutureDate',
  standalone: true,
})
export class IsFutureDatePipe implements PipeTransform {
  public transform(value: Date): boolean {
    return value === null || value === undefined || !(value instanceof Date) || value.valueOf() > new Date().valueOf();
  }
}
